import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { offices, companyInfo } from '../../data/mock';

const LocationSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Zone d'intervention
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Trois bureaux pour vous servir
            <span className="text-blue-600"> au plus près</span>
          </h2>
          <p className="text-slate-600 text-lg">
            Notre zone d'activité couvre les lacs de Neuchâtel, Morat et Léman.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {offices.map((office) => (
            <div
              key={office.id}
              className="bg-slate-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 border border-slate-100"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-700 rounded-xl flex items-center justify-center shadow-lg">
                  <MapPin className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-800">{office.sector}</h3>
                  <span className="text-sm text-blue-600 font-medium">{office.lake}</span>
                </div>
              </div>
              
              <div className="space-y-4 text-slate-600">
                <p className="text-sm">
                  {companyInfo.name}<br />
                  {office.address}<br />
                  {office.city}
                </p>
                <div className="space-y-2">
                  <a
                    href={`tel:${office.phone.replace(/\s/g, '')}`}
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold text-sm"
                  >
                    <Phone className="w-4 h-4" />
                    {office.phone}
                  </a>
                  <a
                    href={`mailto:${office.email}`}
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium text-sm"
                  >
                    <Mail className="w-4 h-4" />
                    {office.email}
                  </a>
                  <div className="flex items-center gap-2 text-slate-600 text-sm">
                    <Clock className="w-4 h-4" />
                    <span>Lun - Sam : 8h - 18h</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
